module.exports = __webpack_public_path__ + "img/icon_fangda.188f202d.svg";